<script setup lang="ts">
import type { StationListItem } from '~/types/stations'

const nuxtApp = useNuxtApp()
const { data: stations } = useAsyncData<StationListItem[]>(
  `stations-trending`,
  () => $fetch(`/api/stations/trending/`),
  {
    getCachedData(key) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
  }
)
</script>

<template>
  <MediaListRow :items="stations" title="Trending Stations" type="stations" />
</template>

<style scoped></style>
